uniform float time;
varying vec2 vUv;
varying vec3 vPosition;
varying float vColorRandom;
varying float vTouch;
uniform sampler2D texture1;

attribute float randoms;
attribute float colorRandoms;

uniform vec4 uTouch0;
uniform vec4 uTouch1;
uniform vec4 uTouch2;
uniform vec4 uTouch3;
uniform vec4 uTouch4;
uniform vec4 uTouch5;
uniform float uTouchRadius;
uniform float uRepelStrength;

float touchInfluence(vec3 worldPos, vec4 touch) {
  if (touch.w < 0.001) return 0.0;
  float d = length(worldPos - touch.xyz);
  return pow(smoothstep(uTouchRadius, 0.0, d), 2.0) * touch.w;
}

void main() {
  vUv = uv;
  vColorRandom = colorRandoms;

  vec3 pos = position;
  vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;

  float t = 0.0;
  t = max(t, touchInfluence(worldPos, uTouch0));
  t = max(t, touchInfluence(worldPos, uTouch1));
  t = max(t, touchInfluence(worldPos, uTouch2));
  t = max(t, touchInfluence(worldPos, uTouch3));
  t = max(t, touchInfluence(worldPos, uTouch4));
  t = max(t, touchInfluence(worldPos, uTouch5));

  vTouch = t;

  if (t > 0.001) {
    float angle = colorRandoms * 6.28318530718;
    float influence = t * 0.65;
    float push = influence * uRepelStrength * mix(0.7, 1.0, randoms);
    pos.x += cos(angle) * push;
    pos.y += sin(angle) * push;
    pos.z += influence * uRepelStrength * 0.02;
  }

  vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
  float pointScale = (30.0 * randoms + 5.0) * (1.0 / max(-mvPosition.z, 0.1));
  gl_PointSize = clamp(pointScale, 1.0, 48.0);
  gl_Position = projectionMatrix * mvPosition;
}
